<template>
    <div class="main">
        <pro-head ref="head" />
        <left-item ref="leftItem" />

        <pro-content></pro-content>
    </div>
</template>

<script>
import proHead from "./components/Hearder.vue";
import leftItem from "./components/leftItem.vue";
import proContent from "./components/content.vue";

export default {
    name: "pro_main",
    components: { proHead, leftItem, proContent },
    data() {
        return {};
    }
};
</script>

<style lang="less">
.main {
    background: #f0f2ee;
    width: 100%;
    height: 100%;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    // padding: 10px 0;
    background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/main/index.vue